export default "__VITE_ASSET__070e7046__"